<template>
	<div v-if="isSending" class="sending-container">
		<img class="image" src="undefined" />
	</div>
	<div @click="handleImageView(message)" v-else-if="isSuccess || isFailed" class="image-container">
		<img class="image" :src="computedSrc" :key="computedSrc" alt="image" />
	</div>
</template>

<script>
export default {
	name: "ChatMessageImage",
	props: {
		message: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			localStatus: this.message._status,
		};
	},
	watch: {
		"message.attachment_url"(newUrl) {
			if (newUrl) {
				this.localStatus = 1;
			}
		},
	},
	computed: {
		// 消息发送状态
		isSending() {
			return this.message._status === 0;
		},
		isSuccess() {
			return this.message._status === 1 || this.message._status === undefined;
		},
		isFailed() {
			return this.message._status === 2;
		},

		computedSrc() {
			// 如果为空，返回一个无效地址，让浏览器加载出 OSS 的404图
			const baseUrl = this.message.attachment_url || "";
			return `${baseUrl}?x-oss-process=image/resize,m_fill,h_150,w_150&_=${Date.now()}`;
		},
	},
	methods: {
		handleImageView(message) {
			this.$emit("handle-image-view", message);
		},
	},
};
</script>

<style lang="less" scoped>
.sending-container,
.image-container {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 150px;
	height: 150px;
	background-color: #f5f5f5;
}

.image-container {
	cursor: pointer;
	background-color: transparent;
}

.image {
	display: block;
	max-width: 100%;
	max-height: 100%;
	cursor: pointer;
	background-color: #d3d3d3;
	object-fit: contain;
}

.image-container .image {
	width: 150px;
	height: 150px;
	object-fit: cover;
}
</style>
